import React, { LegacyRef, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ReactComponent as PhotoIcon } from "../../../../assets/icons/modal/emptyPhoto.svg";
import { IBrand, IBrandCreateDto } from "../../../../types/brands.type";
import SmallWhiteButton from "../../../buttons/WhiteButton/SmallWhiteButton";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  brand: IBrand;
}

const EditBrandForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>(props.brand.name);
  const [note, setNote] = useState<string>(props.brand.description);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [previewUrl, setPreviewUrl] = useState<any>(props.brand.imageUrl);

  const fileInputRef: LegacyRef<HTMLInputElement> | undefined =
    React.createRef();

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const removePhoto = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
  };

  const onClickApply = async () => {
    try {
      let avatar = previewUrl;
      if (selectedImage) {
        const formData = new FormData();
        formData.append("file", selectedImage);
        const response = await authApiService.uploadImage(formData);
        avatar = response.publicUrl;
      }

      const body: IBrandCreateDto = {
        name,
        description: note,
        imageUrl: avatar,
      };

      const response = await authApiService.updateBrand(props.brand.id, body);

      if (response) {
        props.onApply();
      }
    } catch (err: any) {
      toast.error(err.message);
      console.error(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.photoContainer}>
        {previewUrl ? (
          <img src={previewUrl} alt="employee" className={styles.image} />
        ) : (
          <PhotoIcon />
        )}
        <input
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={fileInputRef}
          className={styles.input}
        />
        <SmallWhiteButton onClick={handleButtonClick} title={"Оновити фото"} />
      </div>
      <div className={styles.form}>
        <EditInput
          value={name}
          setValue={setName}
          isRequired
          title="Назва"
        ></EditInput>
        <EditInput
          value={note}
          setValue={setNote}
          title="Примітка"
          isRequired={false}
          isBig={true}
        />
      </div>
      <ModalBottomButtons
        onPressApply={onClickApply}
        onPressBack={props.onClose}
        isDeleteBackButton={true}
        applyTitle="Зберегти"
        backTitle="Видалити"
      />
    </div>
  );
};

export default EditBrandForm;
